var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 69",
    d: "M0.5 26.2668C0.5 20.3389 5.30548 15.5334 11.2333 15.5334H12.7667C18.6945 15.5334 23.5 20.3389 23.5 26.2668C23.5 27.1136 22.8135 27.8001 21.9667 27.8001H2.03333C1.1865 27.8001 0.5 27.1136 0.5 26.2668Z",
    fill: "#EFF4F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5758 16.6686C16.3208 18.7689 14.2907 20.1334 11.9998 20.1334C9.70892 20.1334 7.6788 18.7689 6.42383 16.6686C7.8705 15.9423 9.50407 15.5334 11.2331 15.5334H12.7665C14.4955 15.5334 16.1291 15.9423 17.5758 16.6686Z",
    fill: "#8BA293"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48",
    cx: 11.9997,
    cy: 8.63328,
    r: 8.43333,
    fill: "#FFA692"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfil);
export default __webpack_public_path__ + "static/media/perfil.bf98f15ded07db127f6a43c5db8731ee.svg";
export { ForwardRef as ReactComponent };